export default __webpack_public_path__ + "static/media/BO.d86b52d6.ico";